export const ONBOARDING_ROUTES = {
	ROOT: "/onboarding",
	PROFILE: "/onboarding/profile",
	CREATE_COMMUNITY_PROFILE: "/onboarding/create-community",
	CREATE_COMMUNITY_PERSONALIZE: "/onboarding/create-community/personalize",
	JOIN_COMMUNITY: "/onboarding/join-community",
	PENDING_JOIN_COMMUNITY: "/onboarding/pending-join",
	SELECT_COMMUNITY: "/onboarding/select-community",
} as const;
